var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgSlide = function SvgSlide(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 15,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.456.15v14.7h-2.692v-6.3l-5.117-.001v2.845L.25 7.316l7.398-4.079-.001 3.212 5.117.001V.15h2.692zm11.972 3.456 7.398 4.078-7.398 4.079V8.812h-5.116v-2.1h5.116V3.606zM19.624.15h2.688v14.7h-2.688z",
    fill: "#FFF",
    fillRule: "evenodd"
  })));
};

export default SvgSlide;